module.exports = __webpack_public_path__ + "img/ico_premium.85fc09df.png";